import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { NapalmDroplet } from '../entities/napalmDroplet';
import { getGameRNG } from '../core/rng';

export const WeaponNapalmStrike: WeaponDefinition = {
  id: 'napalmStrike',
  name: 'Napalm Strike',
  icon: 'firestrk.1.png',
  category: 'strike',
  maxAmmo: 1,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: false,

  fire(ctx: WeaponContext): WeaponResult {
    const { world, target } = ctx;

    if (!target) {
      return {
        success: false,
        message: 'Select a target location',
      };
    }

    const dropletCount = 15;
    const spacing = 22;
    const startX = target.x - (dropletCount * spacing) / 2;
    const wind = world.getWind();

    const entities: NapalmDroplet[] = [];

    for (let i = 0; i < dropletCount; i++) {
      const droplet = new NapalmDroplet(
        startX + i * spacing + getGameRNG().nextFloat(-5, 5),
        -20 - i * 8,
        wind,
      );
      entities.push(droplet);
    }

    return {
      success: true,
      entities,
      message: 'Napalm Strike incoming!',
    };
  },
};

export { NapalmDroplet };
